@if (!auth) {
  <mat-drawer-container [hasBackdrop]="false">
    <mat-drawer
      [opened]="true"
      [autoFocus]="false"
      mode="over"
      [ngClass]="showNav ? '!w-[295px]' : '!w-[67px]'"
      class="transition-all ease-out"
      (mouseenter)="showNav = true"
    >
      <div>
        <!-- SYSPOL LOGO -->
        <div
          class="flex flex-row items-center justify-center mt-[26px] gap-[12px] overflow-hidden"
        >
          <img
            class="!w-[50px] !h-[49px]"
            width="50"
            height="49"
            ngSrc="assets/svg/zacatecas.svg"
            priority
            alt="Logo Cancun"
          />
          @if (showNav) {
            <div class="flex flex-col leading-[14px]">
              <p class="font-normal text-[18px] text-white">
                {{ "APP.mun" | translate }}
              </p>
              <p class="font-normal text-[9px] text-grayscales !w-[130px]">
                {{ "APP.bjCoverment" | translate }}
              </p>
              <!-- <p class="font-normal text-[9px] text-grayscales">2021-2027</p> -->
            </div>
          }
        </div>
        <!-- SYSPOL LOGO -->

        <!-- SYSPOL LOGO -->
        <div class="flex items-center justify-center mt-[26px] gap-[12px]">
          <img
            class="!w-[50px] !h-[49px]"
            width="50"
            height="49"
            ngSrc="assets/svg/policia.svg"
            alt="Logo Cancun"
          />
          @if (showNav) {
            <div class="flex flex-col leading-[14px]">
              <p class="font-normal text-[13px] text-grayscales">
                {{ "APP.secretary" | translate }}
              </p>
              <p class="font-bold text-[13px] text-grayscales !w-[130px]">
                {{ "APP.security" | translate }}
              </p>
              <p class="font-bold text-[13px] text-grayscales !w-[130px]">
                {{ "APP.transit" | translate }}
              </p>
            </div>
          }
        </div>
        <!-- SYSPOL LOGO -->

        <!-- MENU LOGO -->
        <div
          class="mt-[18px] flex items-center justify-center gap-[25px] pl-[24px] pr-[24px] overflow-hidden"
        >
          <mat-icon
            (click)="showNavigation()"
            class="!w-[22px] !h-[22px] cursor-pointer shrink-0"
            svgIcon="ic-sidebar"
          ></mat-icon>
          @if (showNav) {
            <p
              (click)="showNavigation()"
              class="za-roboto-500 text-[16px] text-grayscales cursor-pointer overflow-hidden text-nowrap text-ellipsis"
            >
              {{ "NAV.hide" | translate }}
            </p>
          }
        </div>
        <!-- MENU LOGO -->

        <!-- DIVIDER -->
        <div
          class="mt-[15px] mb-[15px] flex items-center justify-center"
          [ngClass]="showNav ? 'pl-[24px] pr-[24px]' : ''"
        >
          <div
            class="h-[1px] w-[80px] bg-[#6e7882]"
            [ngClass]="showNav ? '!w-[100%]' : ''"
          ></div>
        </div>
        <!-- DIVIDER -->

        <!-- NAV -->
        <div class="za-nav overflow-y-scroll">
          @for (row of menuWithPermissions; track row.idMenu; let i = $index) {
            <div>
              <!-- PROFILE -->

              <div
                class="cursor-pointer gap-[10px] !h-[50px] ml-[8px] flex items-center"
                [ngClass]="{
                  'justify-center': !showNav,
                  'za-nav-active': row.idMenu.includes(idMenu),
                }"
                mat-list-item
                (click)="
                  !row.subMenu.length
                    ? goRouter(row.url, row.idMenu[0])
                    : openMenu(i)
                "
              >
                <mat-icon
                  [ngClass]="{
                    'dh-icon-blue': row.idMenu.includes(idMenu),
                    'dh-icon-white': !row.idMenu.includes(idMenu),
                    'ml-[24px]': showNav,
                  }"
                  class="!h-[22px] !w-[22px] shrink-0"
                  svgIcon="{{ row.menuIcon }}"
                ></mat-icon>
                <div
                  class="flex justify-between items-center overflow-hidden"
                  [ngClass]="showNav ? '!w-[205px]' : ''"
                >
                  @if (showNav) {
                    <p
                      [ngClass]="
                        row.idMenu.includes(idMenu)
                          ? 'text-primary-lith-blue'
                          : 'text-grayscales'
                      "
                      class="za-roboto-500 text-[16px] overflow-hidden text-nowrap text-ellipsis"
                    >
                      {{ row.menuName | translate }}
                    </p>
                    @if (row.subMenu.length) {
                      <mat-icon
                        class="!h-[22px] !w-[22px] mat-icon-no-color transform transition-transform duration-300 shrink-0"
                        [class.rotate-180]="row.open"
                        svgIcon="ic-down-blue"
                      ></mat-icon>
                    }
                  }
                </div>
              </div>
              @if (row.open) {
                <div
                  class="za-submenu-wrapper"
                  [ngClass]="showNav ? 'ml-[40px]' : 'ml-[8px]'"
                >
                  @if (showNav) {
                    @for (
                      sub of row.subMenu;
                      track sub.idMenu;
                      let j = $index
                    ) {
                      <div
                        class="!h-[50px] ml-[30px] flex items-center gap-[12px] cursor-pointer"
                        (click)="goRouter(sub.url, sub.idMenu)"
                      >
                        <mat-icon
                          svgIcon="{{ sub.subMenuIcon }}"
                          class="!w-[22px] !h-[22px] shrink-0"
                          [ngClass]="
                            sub.idMenu === idMenu
                              ? 'dh-icon-blue'
                              : 'dh-icon-white'
                          "
                        ></mat-icon>
                        <p
                          class="za-roboto-500 text-[16px]"
                          [ngClass]="
                            idMenu === sub.idMenu
                              ? 'text-primary-lith-blue'
                              : 'text-white'
                          "
                        >
                          {{ sub.subMenuName | translate }}
                        </p>
                      </div>
                    }
                  } @else {
                    @for (
                      sub of row.subMenu;
                      track sub.idMenu;
                      let j = $index
                    ) {
                      <div
                        class="!h-[50px] flex items-center justify-center cursor-pointer"
                        (click)="goRouter(sub.url, sub.idMenu)"
                      >
                        <mat-icon
                          svgIcon="{{ sub.subMenuIcon }}"
                          class="!w-[22px] !h-[22px] shrink-0"
                          [ngClass]="
                            sub.idMenu === idMenu
                              ? 'dh-icon-blue'
                              : 'dh-icon-white'
                          "
                        ></mat-icon>
                      </div>
                    }
                  }
                </div>
              }
              <!-- PROFILE -->
            </div>
          }
        </div>

        <!-- SIGN OFF -->
        <div class="za-sign-off">
          <div
            (click)="signOff()"
            class="cursor-pointer flex items-center justify-center mb-[10px] gap-[15px] overflow-hidden"
          >
            <mat-icon
              class="cursor-pointer dh-icon-white shrink-0"
              svgIcon="ic-logout"
            ></mat-icon>
            @if (showNav) {
              <p
                class="text-[16px] za-roboto-500 text-grayscales text-ellipsis overflow-hidden text-nowrap"
              >
                {{ "NAV.signOff" | translate }}
              </p>
            }
          </div>
          @if (showNav) {
            <p
              class="text-white text-[16px] font-semibold flex items-center justify-center"
            >
              v{{ version }}
            </p>
          }
        </div>
        <!-- NAV -->
      </div>
    </mat-drawer>
    <mat-drawer-content (mouseenter)="showNav = false" id="drawerW">
      <div class="za-contain-body">
        @defer {
          @if (!auth) {
            <div class="za-contain-header-box">
              <header class="za-contain-header">
                <app-header [onInput]="idMenu" />
              </header>
            </div>
          }
        }
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <router-outlet></router-outlet>
}
